export default "__VITE_ASSET__D0Xk7Cv1__"